import { isSlovakAddress } from '@/utils/address';
import persons from '@/mixins/persons';
import GENERALSK from '@/locales/sk/general';
import GENERALEN from '@/locales/en/general';

const step7 = {
  SK: GENERALSK,
  EN: GENERALEN,
};

export default {
  mixins: [persons],
  methods: {
    createNewAddress() {
      return new this.$kotlin.model.Address(
        this.$store.getters.getSlovakia,
        null, null, null, null,
      );
    },
  },
  computed: {
    /**
     * Computed returns all slovak unique slovak addresses where
     * postal addresses have highest priority then temporary and permanent address
     *
     * @returns array -
     * */
    uniqueSlovakAddresses() {
      const setOfAddresses = new Set();
      const prioritizedAddresses = this.insuredPersons
        .map((person) => {
          if (!person.postalAddressSameAsAddress && isSlovakAddress(person.postalAddress)) {
            const {
              city, street, streetNumber, zip,
            } = person.postalAddress;
            if (!city || !street || !streetNumber || !zip) return person.temporaryResidence;
            return person.postalAddress;
          }
          if (person.hasTemporaryResidence && isSlovakAddress(person.temporaryResidence)) return person.temporaryResidence;
          return person.address;
        });
      const uniqueAddresses = [];
      prioritizedAddresses.forEach((address) => {
        const addressString = `${address.street}-${address.streetNumber}-${address.city}-${address.zip}`;
        if (!setOfAddresses.has(addressString)) {
          uniqueAddresses.push(address);
          setOfAddresses.add(addressString);
        }
      });
      return uniqueAddresses.filter((address) => {
        const {
          city, zip, street, streetNumber,
        } = address;
        return city && zip && street && streetNumber;
      });
    },
    /**
    * @returns all unique slovak addresses with other option
    * */
    uniqueSlovakAddressesWithOtherOption() {
      const translations = step7[this.model.locale.name$];
      return [
        ...this.uniqueSlovakAddresses.map((address) => {
          const {
            street, streetNumber, city, zip,
          } = address;
          return { name$: address, label: `${street} ${streetNumber}, ${city} ${zip}` };
        }),
        {
          name$: new this.$kotlin.model.Address(
            this.$store.getters.getSlovakia,
            null, null, null, null,
          ),
          label: translations.otherAddress,
        },
      ];
    },
  },
};
